import defaultPortugueseMessages from 'ra-language-portuguese';

export const portugueseMessages = {
  ...defaultPortugueseMessages,
  resources: {
    users: {
      name: 'Usuário |||| Usuários',
      fields: {
        id: 'ID',
        name: 'Nome',
        email: 'Email',
        phone: 'Telefone',
        profession: 'Profissão',
        location: 'Localização',
        avatarUrl: 'Avatar',
        isVerified: 'Verificado',
        twoFactorEnabled: '2FA Habilitado',
        followersCount: 'Seguidores',
        followingCount: 'Seguindo',
        createdAt: 'Criado',
        updatedAt: 'Atualizado',
      },
      tabs: {
        general: 'Informações Gerais',
        security: 'Segurança',
        social: 'Conexões Sociais',
        challenges: 'Desafios',
        orders: 'Pedidos',
      },
      social: {
        followers: 'Seguidores',
        following: 'Seguindo',
        no_followers: 'Sem seguidores',
        no_following: 'Não segue ninguém',
        loading_followers: 'Carregando seguidores...',
        loading_following: 'Carregando seguindo...',
        error: 'Erro',
      },
      challenges: {
        created_challenges: 'Desafios Criados',
        no_challenges: 'Nenhum desafio criado',
        loading: 'Carregando desafios...',
        type: 'Tipo',
        status: 'Status',
        mode: 'Modo',
        participants: 'Participantes',
        current_streak: 'Sequência Atual',
        best_streak: 'Melhor Sequência',
        created: 'Criado',
        start: 'Início',
        end: 'Fim',
        group: 'Grupo',
        personal: 'Pessoal',
      },
      orders: {
        supplement_orders: 'Pedidos de Suplementos',
        no_orders: 'Nenhum pedido',
        loading: 'Carregando pedidos...',
        order_id: 'ID do Pedido',
        quantity: 'Quantidade',
        status: 'Status',
        payment: 'Pagamento',
        paid: 'Pago',
        not_paid: 'Não pago',
        context: 'Contexto',
        recommendation_reason: 'Motivo da Recomendação',
        created: 'Criado',
        paid_at: 'Pago em',
      },
    },
    challenges: {
      name: 'Desafio |||| Desafios',
      fields: {
        id: 'ID',
        title: 'Título',
        description: 'Descrição',
        type: 'Tipo',
        status: 'Status',
        mode: 'Modo',
        author: 'Autor',
        participants: 'Participantes',
        createdAt: 'Criado',
        updatedAt: 'Atualizado',
      },
    },
    supplements: {
      name: 'Suplemento |||| Suplementos',
      fields: {
        id: 'ID',
        name: 'Nome',
        description: 'Descrição',
        price: 'Preço',
        emoji: 'Emoji',
        benefits: 'Benefícios',
        duration: 'Duração',
      },
    },
    supplementOrders: {
      name: 'Pedido |||| Pedidos',
      fields: {
        id: 'ID do Pedido',
        client: 'Cliente',
        supplement: 'Suplemento',
        quantity: 'Quantidade',
        totalPrice: 'Total',
        status: 'Status',
        isPaid: 'Pago',
        createdAt: 'Criado',
        paidAt: 'Pago em',
      },
    },
    paymentTransactions: {
      name: 'Pagamento |||| Pagamentos',
      fields: {
        id: 'ID',
        client: 'Cliente',
        order: 'Pedido',
        amount: 'Valor',
        currency: 'Moeda',
        status: 'Status',
        method: 'Método',
        provider: 'Provedor',
        createdAt: 'Criado',
      },
    },
    challengeUpdates: {
      name: 'Evento |||| Eventos de Desafios',
      fields: {
        id: 'ID',
        type: 'Tipo',
        content: 'Conteúdo',
        user: 'Usuário',
        challenge: 'Desafio',
        dayNumber: 'Dia',
        createdAt: 'Criado',
      },
    },
    chatMessages: {
      name: 'Mensagem |||| Mensagens do Chat',
      fields: {
        id: 'ID',
        role: 'Papel',
        content: 'Conteúdo',
        user: 'Usuário',
        createdAt: 'Criado',
      },
    },
  },
  // Challenge types
  challengeTypes: {
    QUIT_SMOKING: 'Parar de Fumar',
    QUIT_PORN: 'Parar Pornografia',
    QUIT_SUGAR: 'Parar Açúcar',
    QUIT_ALCOHOL: 'Parar Álcool',
    EXERCISE: 'Exercício',
    MEDITATION: 'Meditação',
    READING: 'Leitura',
    WATER_DRINKING: 'Beber Água',
    SLEEP_SCHEDULE: 'Horário de Sono',
    NO_SOCIAL_MEDIA: 'Sem Redes Sociais',
    CUSTOM: 'Personalizado',
  },
  // Challenge statuses
  challengeStatuses: {
    ACTIVE: 'Ativo',
    PAUSED: 'Pausado',
    COMPLETED: 'Concluído',
    FAILED: 'Falhado',
  },
  // Order statuses
  orderStatuses: {
    PENDING: 'Pendente',
    PROCESSING: 'Processando',
    SHIPPED: 'Enviado',
    DELIVERED: 'Entregue',
    CANCELLED: 'Cancelado',
  },
  // Payment statuses
  paymentStatuses: {
    PENDING: 'Pendente',
    COMPLETED: 'Concluído',
    FAILED: 'Falhado',
    CANCELLED: 'Cancelado',
    REFUNDED: 'Reembolsado',
  },
  // Payment methods
  paymentMethods: {
    CARD: 'Cartão',
    PAYPAL: 'PayPal',
    BANK_TRANSFER: 'Transferência Bancária',
    CRYPTO: 'Criptomoeda',
  },
  // Payment providers
  paymentProviders: {
    STRIPE: 'Stripe',
    PAYPAL: 'PayPal',
    BANK: 'Banco',
    CRYPTO: 'Crypto',
  },
  dashboard: {
    title: 'Dashboard',
    stats: {
      total_users: 'Total de Usuários',
      total_challenges: 'Total de Desafios',
      total_orders: 'Total de Pedidos',
      total_activities: 'Total de Atividades',
      activities_subtitle: 'Check-ins, mudanças de status',
    },
    charts: {
      user_registration: 'Registro de Usuários',
      challenge_types: 'Tipos de Desafios',
      order_statuses: 'Status dos Pedidos',
      activity_types: 'Tipos de Atividades',
      daily_activity: 'Atividade Diária (30 dias)',
    },
  },
  challengeActivityTypes: {
    START: 'Início do Desafio',
    CHECKIN: 'Check-in',
    STATUS_CHANGE: 'Mudança de Status',
    COMMENT: 'Comentário',
    LIKE: 'Curtida',
    COMPLETE: 'Conclusão',
    FAIL: 'Falha',
  },
};
